"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleQRcodeAndText = exports.StyleQRCodeImage = exports.StyleModalContainer = exports.StyleLeftImage = exports.StyleButtonRedirect = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _img = _interopRequireDefault(require("webmotors-react-pj/img"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleModalContainer = exports.StyleModalContainer = _styledComponents.default.div.withConfig({
  displayName: "StyleModalContainer",
  componentId: "sc-19pqwe1-0"
})(["display:flex;flex-direction:row;height:240px;@media ", "{height:auto;}"], _responsive.default.lg);
const StyleLeftImage = exports.StyleLeftImage = (0, _styledComponents.default)(_img.default).withConfig({
  displayName: "StyleLeftImage",
  componentId: "sc-19pqwe1-1"
})(["display:none;width:180px;height:345px;position:absolute;top:-8px;left:0;@media ", "{width:auto;height:345px;display:block;border-top-left-radius:5px;border-bottom-left-radius:5px;top:0px;}"], _responsive.default.lg);
const StyleQRCodeImage = exports.StyleQRCodeImage = (0, _styledComponents.default)(_img.default).withConfig({
  displayName: "StyleQRCodeImage",
  componentId: "sc-19pqwe1-2"
})(["margin-bottom:28px;display:none;width:69px;height:69px;@media ", "{display:block;}"], _responsive.default.lg);
const StyleQRcodeAndText = exports.StyleQRcodeAndText = _styledComponents.default.div.withConfig({
  displayName: "StyleQRcodeAndText",
  componentId: "sc-19pqwe1-3"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;position:absolute;left:0;top:58px;margin:20px;h2{font-size:18px;font-weight:500;line-height:26px;letter-spacing:0em;text-align:left;margin-bottom:10px;}p{font-size:12px;font-weight:400;line-height:18px;letter-spacing:0em;text-align:left;margin-bottom:10px;}@media ", "{margin-left:180px;position:relative;width:auto;top:0;margin:0 0 0 168px;h2{font-size:20px;line-height:30px;}}"], _responsive.default.lg);
const StyleButtonRedirect = exports.StyleButtonRedirect = _styledComponents.default.div.withConfig({
  displayName: "StyleButtonRedirect",
  componentId: "sc-19pqwe1-4"
})(["display:block;@media ", "{display:none;}"], _responsive.default.lg);